import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background-color: #f0faff;
  height: 40px;
  min-width: 18%;
  align-items: center;
  cursor: pointer;
`;

const FileNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileName = styled.span`
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 10px;
`;

const FileSize = styled.span`
  color: #666;
  font-size: 8px;
`;

const DownloadIcon = styled(InnoIcons.DownloadIcon)`
  font-size: 15px;
  margin-left: 3px;
`;

const SC = {
  Container,
  FileNameContainer,
  FileName,
  FileSize,
  DownloadIcon,
};

export default SC;
